import { render, staticRenderFns } from "./QueryExam.vue?vue&type=template&id=b9d5a50e&scoped=true"
import script from "./QueryExam.vue?vue&type=script&lang=js"
export * from "./QueryExam.vue?vue&type=script&lang=js"
import style0 from "./QueryExam.vue?vue&type=style&index=0&id=b9d5a50e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9d5a50e",
  null
  
)

export default component.exports